<template>
  <div class="pi-cohort">
    <p v-if="!rows.length" class="pi-cohort__empty">{{ emptyText }}</p>
    <div v-else class="pi-cohort__scroll" tabindex="0" role="region" :aria-label="caption">
      <table class="pi-cohort__table">
        <caption class="pi-sr">{{ caption }}</caption>
        <thead>
        <tr>
          <pi-th v-for="column in columns" :key="column.key" :column="column"/>
        </tr>
        </thead>
        <tbody>
        <tr v-for="row in rows" :key="row.key">
          <th scope="row" class="pi-cohort__name">
            {{ row.label }}
            <span v-if="row.derived" class="pi-badge pi-badge--info">retroativo</span>
          </th>
          <td class="is-num pi-cohort__size">
            {{ row.sizeText }}
            <span v-if="row.companiesText && type !== 'company'" class="pi-cohort__sub">{{ row.companiesText }}</span>
          </td>
          <td v-for="cell in row.cells" :key="row.key + '-' + cell.offset" class="pi-cohort__cell"
              :class="{ 'is-pending': cell.pending, 'is-missing': cell.missing }" :style="cell.style" :title="cell.title">
            {{ cell.text }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <ul v-if="rows.length" class="pi-cohort__legend" aria-label="Legenda da escala de cores">
      <li v-for="item in legend" :key="item.step" class="pi-cohort__legend-item">
        <span class="pi-cohort__swatch" :style="{ background: item.background, color: item.color }">{{ item.label }}</span>
      </li>
      <li class="pi-cohort__legend-item">
        <span class="pi-cohort__swatch is-pending">pendente dd/mm</span> coorte sem maturação: o valor sai na data indicada
      </li>
    </ul>
  </div>
</template>

<script>
import piTh from "./piTh.vue";
import { cohortRows, scaleLegend } from "./piScale.js";

const GRANULARITY_NAMES = { day: "dia", week: "semana", month: "mês" };

export default {
  name: "pi-cohort-matrix",
  components: { piTh },
  props: {
    columns: { type: Array, default: () => [] },
    offsets: { type: Array, default: () => [] },
    cohorts: { type: Array, default: () => [] },
    granularity: { type: String, default: "week" },
    type: { type: String, default: "user" },
    emptyText: { type: String, default: "Nenhuma coorte no período." },
  },
  computed: {
    rows() {
      return cohortRows(this.cohorts, this.offsets);
    },
    legend() {
      return scaleLegend();
    },
    caption() {
      const subject = this.type === "company" ? "empresas" : "usuários";
      const unit = GRANULARITY_NAMES[this.granularity] || "período";
      return "Retenção acumulada de " + subject + " por coorte, por " + unit + " desde a entrada";
    },
  },
};
</script>

<style src="./pi.css"></style>

<style scoped>
.pi-cohort__scroll {
  width: 100%;
  overflow-x: auto;
}

.pi-cohort__table {
  border-collapse: separate;
  border-spacing: 2px;
  font-size: 12px;
}

.pi-cohort__table th,
.pi-cohort__table td {
  padding: 6px 8px;
  white-space: nowrap;
}

.pi-cohort__table thead th {
  font-weight: 700;
  color: #4e5560;
}

.pi-cohort__table .is-num {
  text-align: right;
}

.pi-cohort__name {
  font-weight: 600;
  text-align: left;
}

.pi-cohort__sub {
  display: block;
  font-size: 11px;
  font-weight: 400;
  color: #6b7280;
}

.pi-cohort__cell {
  min-width: 64px;
  border-radius: 3px;
  text-align: center;
  font-weight: 600;
}

.pi-cohort__cell.is-pending {
  border: 1px dashed #c5cad3;
  background: #ffffff;
  color: #6b7280;
  font-weight: 400;
}

.pi-cohort__cell.is-missing {
  color: #6b7280;
  font-weight: 400;
}

.pi-cohort__legend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin: 10px 0 0;
  padding: 0;
  list-style: none;
  font-size: 11px;
  color: #4e5560;
}

.pi-cohort__swatch {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  font-weight: 600;
}

.pi-cohort__swatch.is-pending {
  border: 1px dashed #c5cad3;
  background: #ffffff;
  color: #6b7280;
  font-weight: 400;
}

.pi-cohort__empty {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piCohortMatrix.vue